import axios from 'axios'
import amplitude from 'amplitude-js'

/* eslint-disable */
String.prototype.getValueByKey = function getValueByKey(k) {
  const p = new RegExp(`\\b${k}\\b`, 'gi');
  return this.search(p) !== -1 ? decodeURIComponent(this.substr(this.search(p) + k.length + 1).substr(0, this.substr(this.search(p) + k.length + 1).search(/(&|;|$)/))) : '';
};
/* eslint-enable */

/* --------------------------------
  REJECT ENVELOPE
  * Reject Document
  @return Promise
--------------------------------- */
export function rejectDocument ({ reason }) {
  return axios.post(`${process.env.VUE_APP_API_URL}/reject`, {
    rejection_reason: reason
  })
    .then(response => {
      amplitude.getInstance().logEvent('envelope_reject')
      return response
    })
}

const processFields = (allFields) => {
  const fields = []
  allFields.forEach((field) => {
    const contractId = field.contract_id
    const contractSentId = field.contract_sent_id
    const inputId = field.id
    let inputValue = field.content
    let inputFormat = ''
    const inputFont = field.font || 'arial'
    const inputSize = field.font_size || 18

    switch (field.type) {
      case 'signature':
        if (field.content !== null && field.content !== '') {
          inputFormat = 'typed'
          inputValue = field.content
        } else if (field.drawn_json && field.drawn_json !== '') {
          inputFormat = 'drawn'
          inputValue = JSON.stringify(field.drawn_json)
        } else if (field.upload !== null && field.upload !== '') {
          inputFormat = 'upload'
          inputValue = field.upload
        }
        break
      case 'checkbox':
        inputValue = field.content
        break
      case 'radio':
        inputValue = field.content
        break
      case 'upload':
        // uploaded files
        if (Array.isArray(field.upload)) {
          inputFormat = 'upload-field'
          inputValue = []
          field.upload.forEach((upload) => {
            inputValue.push(upload.uuid)
          })
          inputValue = JSON.stringify(inputValue)
        }
        break
      default:
        inputValue = field.content
    }

    fields.push({
      inputId,
      contractId,
      contractSentId,
      inputValue,
      inputFormat,
      inputFont,
      inputSize
    })
  })

  return fields
}

/* --------------------------------
  SUBMIT ENVELOPE
  * Submit document with all
  * data that has been added
  @param store - Object of fields
  @return Promise
--------------------------------- */
export function submitEnvelope ({ store, widgetSignerName, widgetSignerEmail }) {
  const fields = processFields(store.getters.fields)

  if (store.getters.isWidget) {
    if (!widgetSignerName || !widgetSignerEmail) throw Error('Need signer name and email to submit widget')

    const request = {
      widget: store.state.requestedEnvelope.widgetCode,
      name: widgetSignerName,
      email: widgetSignerEmail,
      inputs: fields
    }

    return axios.post(`${process.env.VUE_APP_API_URL}/sign-widget`, request).then(response => response)
  }

  return axios.post(`${process.env.VUE_APP_API_URL}/sign-envelope`, {
    inputs: fields
  }).then(response => {
    amplitude.getInstance().logEvent(store.getters.isWidget ? 'envelope_signed_widget' : 'envelope_signed_regular')
    return response
  })
}

/**
 * @param {string} envelopeFingerprint
 * @param {string} expires
 * @param {string} signature
 */
export function verifyWidget (envelopeFingerprint, expires, signature) {
  const query = new URLSearchParams({ expires, signature }).toString()

  return axios
    .post(`${process.env.VUE_APP_API_URL}/verify-widget/${envelopeFingerprint}?${query}`)
}

export default {
  submitEnvelope,
  rejectDocument
}
